import Member from 'iam/models/Member'
import BillingStore from 'billing/BillingStore'
import PayoutMethodStore from 'payouts/pro/PayoutMethodStore'
import { computed, observable, makeObservable } from 'mobx'
import { task, TaskGroup } from 'mobx-task'
import { PayoutMethod } from 'payouts/pro/PayoutMethod'
import { Id, Nullable } from 'types/definitions'

export default class ProfilePayoutMethodViewModel {
  /**
   * Payout method of the current user.
   */
  @observable
  payoutMethod: Nullable<PayoutMethod> = null

  /**
   * Task group.
   */
  private tasks

  constructor(
    public member: Member,
    private billingStore: BillingStore,
    private payoutMethodStore: PayoutMethodStore,
  ) {
    makeObservable(this)
    this.tasks = TaskGroup<any, any>([this.activate, this.addPayoutMethod])
  }

  /**
   * Disabled view model.
   */
  @computed
  get disabled() {
    return this.tasks.pending
  }

  /**
   * Activates view model.
   */
  activate = task(async () => {
    this.payoutMethod = await this.fetchPayoutMethod(this.member.user.publicId)
  })

  /**
   * Adds a payout method.
   */
  addPayoutMethod = task.resolved(async () => {
    this.billingStore.redirectToStripeConnect()
  })

  fetchPayoutMethod = task.resolved((userPublicId: Id) =>
    this.payoutMethodStore.fetchPayoutMethod(userPublicId),
  )
}
